import React, { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import UserManagementComponent from "../../../features/adminDashboard/usermanagement/UserManagement/UserManagement";
import CreateUser from "../../../features/adminDashboard/usermanagement/CreateUser";

const UserManagement = () => {
  const [activeTab, setActiveTab] = useState("list");
  const onHandleCancel = () => setActiveTab("create");

  return (
    <Dashboard
      title="User Management"
      description="Manage user accounts and permissions"
    >
      <div className="flex border-b mb-6">
        <div className="w-full h-full px-4 pb-8">
          {/* Tab Navigation */}
          <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
            <button
              onClick={() => setActiveTab("list")}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                activeTab === "list"
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              List Users
            </button>
            <button
              onClick={() => setActiveTab("create")}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                activeTab === "create"
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Create User
            </button>
          </div>
        </div>
      </div>
      {activeTab === "list" && (
        <UserManagementComponent onSetActiveTab={setActiveTab} />
      )}
      {activeTab === "create" && <CreateUser onHandleCancel={onHandleCancel} />}
    </Dashboard>
  );
};

export default UserManagement;
